import * as React from 'react';
import MultiSelectModal from '../../../misc/components/queryTable/MultiSelectModal';
import {
    Query,
    QueryCondition,
    QueryFilter,
    SpirometrySessionMetadata,
    VisitScheduleItem
} from "../../../misc/api/apiTypes";
import { useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';

export const VisitFilterMember = "Visit.Name";
const VisitQueryMember = "Label";
const VisitFilterQueryCondition = QueryCondition.Equal;
export const VisitHeader = "Visit";

interface VisitFilterProps {
    studyId: string;
    onClose: (member: string, condition: QueryCondition, values: string[]) => void;
    query: Query<SpirometrySessionMetadata>;
}

const GetQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
    return query.Filters.find(filter => filter.Member === VisitFilterMember && filter.Condition === VisitFilterQueryCondition);
}

const VisitFilterModal = ({ studyId, onClose, query }: VisitFilterProps): JSX.Element => {

    const queryFilter = GetQueryFilter(query) || { Values: [] };

    const [values, setValues] = React.useState<string[]>(queryFilter.Values as string[]);

    const [allVisits, setAllVisits] = React.useState<VisitScheduleItem[]>([]);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        legacyClient.getVisitSchedule({ Filters: [{ Member: "StudyId", Values: [studyId] }] }).then(visitQ => {
            setAllVisits(visitQ.Data);
        });
    }, []);

    return (<MultiSelectModal header={VisitHeader + ' Filter'}
        isLoading={!allVisits}
        show={true}
        options={allVisits.sort((a, b) => a.DisplayOrder - b.DisplayOrder)}
        valueKey={VisitQueryMember}
        labelKey={VisitQueryMember}
        values={values}
        onChange={(updatedValues: string[]) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(v => v[VisitQueryMember]) : null);
        }}
        onClose={() => {
            onClose(VisitFilterMember, VisitFilterQueryCondition, values);
        }}
        onClear={() => {
            onClose(VisitFilterMember, VisitFilterQueryCondition, []);
        }}
    />)
}

export default VisitFilterModal;
